import { Message } from "@/components/bp/bp-ui";

export const SectionWithInfo = (props: { title: string; info: string; children: React.ReactNode; }) => {
    return (<>
        <Message info content={props.info} />
        {props.children}
    </>
    );
};
